<script setup lang="ts" name="ProfileChangePassword">
import Card from '~/components/Card.vue';
import FormChangePassword from '~/components/FormChangePassword.vue';
</script>

<template>
  <Card>
    <p class="mb-4 text-subtitle-1 text-charcoal-9">Reset Password</p>

    <FormChangePassword />
  </Card>
</template>
